import { Fragment } from 'react';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { StepperSteps, StepperStep } from 'types';

import cx from 'classnames';
import styles from './Stepper.module.scss';

export type StepperSidebarProps = {
  stepperName?: string;
  steps: StepperSteps;
  setStep?: (stepIndex: number) => void;
  currentStep: StepperStep;
  passedSteps: string[];
};

export const StepperSidebar = ({ stepperName, steps, currentStep, setStep, passedSteps }: StepperSidebarProps) => {
  return (
    <div className={styles.sidebarWrapper}>
      <div className={styles.logo}>
        <Link href={'/'} legacyBehavior={true}>
          <a>
            <Image src="/icons/logo.svg" width={156} height={24} alt="SENDY" />
          </a>
        </Link>
      </div>
      <div className={styles.sidebarContainer}>
        <div className={styles.stepperName}>{stepperName}</div>
        {currentStep && steps.map((step, index) => (
          <Fragment key={index}>
            {!step.isHidden ? (
              <div style={{cursor: setStep && passedSteps.includes(step.stepName) ? 'pointer' : null}} className={styles.stepMarker} onClick={() => setStep && passedSteps.includes(step.stepName) && setStep(index)}>
                <p className={cx(styles.item, { [styles.itemActive]: step.stepName === currentStep.stepName })}>
                  {step.stepName}
                </p>
                {passedSteps.includes(step.stepName) && (
                  <Image src="/icons/checkbox/CheckCircle.svg" width={24} height={24} alt="Passed" />
                )}
              </div>
            ) : null}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
